import React from "react";
import Navbar from "../../CommonWidget/Navbar/Navbar";
import Footer from "../../CommonWidget/Footer/Footer";
import { Link } from "react-router-dom";

const JobsAbroad = () => {
  const jobs = [
    {
      id: 1,
      icon: "https://a.slack-edge.com/80588/marketing/img/meta/favicon-32.png",
      title: "Lead Product Designer",
      description:
        "We are looking for a lead product designer. A good suitable professional person for this very important role. Anyone can apply for this...",
      tags: ["Fulltime", "Remote"],
      location: "Worldwide",
      postedDays: 5,
    },
    {
      id: 2,
      icon: "https://byjus.com/wp-content/uploads/2022/10/favicon-32x32.png",
      title: "Front-end Developer",
      description:
        "We are looking for a front end developer. A good suitable professional person for this very important role. Anyone can apply for this...",
      tags: ["Fulltime", "Remote"],
      location: "Sylhet, Bangladesh",
      postedDays: 4,
    },
  ];

  const benefits = [
    {
      icon: {
        component: (
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
            />
          </svg>
        ),
        bg: "bg-red-500",
      },
      title: "Global Opportunities",
      description:
        "Access job openings in over 50 countries, tailored to your skills and experience.",
    },
    {
      icon: {
        component: (
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
            />
          </svg>
        ),
        bg: "bg-yellow-500",
      },
      title: "Support for Your Journey",
      description:
        "From visas to relocation tips, we'll guide you every step of the way.",
    },
    {
      icon: {
        component: (
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
            />
          </svg>
        ),
        bg: "bg-green-500",
      },
      title: "Make an Impact",
      description:
        "Empower students worldwide with knowledge that transforms lives and communities.",
    },
    {
      icon: {
        component: (
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
            />
          </svg>
        ),
        bg: "bg-blue-500",
      },
      title: "Build Your Career",
      description:
        "Enhance your teaching expertise with international exposure and professional development opportunities.",
    },
  ];

  const BenefitsCard = ({ icon, title, description }) => (
    <div className="flex flex-col items-center text-center p-6">
      <div className={`rounded-full p-4 mb-4 ${icon.bg}`}>{icon.component}</div>
      <h3 className="font-semibold text-lg mb-2">{title}</h3>
      <p className="text-gray-600 text-sm">{description}</p>
    </div>
  );

  return (
    <main>
      <Navbar />
      <div className="relative">
        {/* Background Image with Overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('/images/overseas.png')` }}
        >
          <div className="absolute inset-0 bg-black opacity-50"></div>
        </div>

        {/* Content */}
        <div className="relative h-full flex flex-wrap gap-8 items-center justify-around text-white p-6 px-4 md:px-8">
          <div className="flex flex-col align-center justify-center">
            <h1 className="text-4xl text-white md:text-5xl font-bold text-center mb-6">
              Teach Beyond Borders
              <br />
              Inspire the World
            </h1>

            <p className="text-lg md:text-xl text-center text-gray-300 mb-8 max-w-2xl">
              Discover premium part-time and full-time teaching opportunities in
              abroad. Explore roles in schools, colleges, and home tuitions
              across the Middle East, Africa, Southeast Asia, and beyond.
            </p>

            <Link
              to="/register_tutor"
              className="bg-blue-600 hover:bg-blue-700 text-white text-center font-semibold py-3 px-8 rounded-md transition-colors duration-200"
            >
              Start your journey today and make an impact! 🚀
            </Link>
          </div>

         
        </div>
      </div>

      <a href="https://www.onlineteacherstraining.com/" target="_blank" class="rounded-xl w-full">
     <img src="https://www.onlineteacherstraining.com/img/logo-new.png" className="w-48 mx-auto" />
      </a>

      <section className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
          {/* Left side - Image with decorative elements */}
          {/* Main image */}
          <div className="md:w-1/2 overflow-hidden">
            <img
              src="/images/hireTeacher2.png"
              alt="Students studying together"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right side - Content */}
          <div className="md:w-1/2 flex flex-col gap-6">
            <h2 className="text-5xl font-bold">
              Teaching <br />
              Opportunities Abroad
            </h2>

            <p className="text-gray-600 text-lg">
              Your dream teaching job abroad is just a click away. Don’t wait –
              make an impact and start your global teaching journey today!
            </p>

            <Link
              to="/register1"
              className="w-fit bg-emerald-500 text-white px-6 py-3 rounded-md hover:bg-emerald-600 transition-colors"
            >
              Register Now
            </Link>
          </div>
        </div>
      </section>

      <section className="container mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold mb-12 text-center">Key Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <BenefitsCard
              key={index}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
            />
          ))}
        </div>
      </section>

      <section className="py-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-between items-center mb-12">
            <h2 className="text-3xl font-bold">Overseas Jobs</h2>
            <Link
              to="/register_tutor"
              className="text-blue-600 hover:text-blue-700 font-medium flex items-center"
            >
              View All
              <svg
                className="w-4 h-4 ml-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </Link>
          </div>

          <div className="space-y-6">
            {jobs.map((job) => (
              <div
                key={job.id}
                className="border rounded-lg p-6 flex items-start justify-between"
              >
                <div className="flex items-start space-x-4">
                  <img src={job.icon} alt="" className="w-10 h-10 rounded-lg" />
                  <div>
                    <h3 className="text-xl font-bold mb-2">{job.title}</h3>
                    <p className="text-gray-600 mb-4">{job.description}</p>
                    <div className="flex items-center space-x-6">
                      <div className="flex space-x-2">
                        {job.tags.map((tag) => (
                          <span
                            key={tag}
                            className="bg-yellow-50 text-gray-800 px-3 py-1 rounded-full text-sm"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <div className="flex items-center space-x-4 text-gray-500">
                        <span className="flex items-center">
                          <svg
                            className="w-4 h-4 mr-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          {job.location}
                        </span>
                        <span className="flex items-center">
                          <svg
                            className="w-4 h-4 mr-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          {job.postedDays} days ago
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <Link
                  to="/register_tutor"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md"
                >
                  Apply Now
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default JobsAbroad;
